/**
 * @file   src\components\Onboarding\Dashboard\LeftpanelTab.js
 * @brief  This file is responsible for handling general/match tabs view handling
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React, { useState, createContext, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import LeftpanelTabContent from "./v2/LeftpanelTabContent";
import LeftpanelTabContentRight from "./LeftpanelTabContentRight";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "../../../helpers/common";
import { useLocation, useNavigate } from "react-router-dom";
import { pageURLs } from "@/constants";

export const filterContext = createContext();
const LeftpanelTab = (props) => {
  const {
    updateFilter,
    filterQuery,
    handleGitchGenieFilter,
    clearFilterGitchaGenie,
    updateFilterGitchaGenie,
    selectedProperty,
    setSelectedProperty,
    setUserLocation,
    gitchaNotAvailble,
    userLocation,
    checkGitchaAvailableInLoc,
  } = props;

  const location = useLocation();
  const [key, setKey] = useState(() => {
    if (window.location.pathname === "/match") return "match";
    return getLocalStorage("FilterTabKey") || "General";
  });
  const path = location.pathname;
  const navigate = useNavigate();
  useEffect(() => {
    if (path === "/match") {
      //To show matches want ads for link from email
      setKey("match");
      setLocalStorage("FilterTabKey", "match");
      removeLocalStorage("selectedPropertyId");
      removeLocalStorage("MatchSelectedClient");
    } else if (getLocalStorage("FilterTabKey")) {
      setKey(getLocalStorage("FilterTabKey"));
    } else {
      setKey("General");
    }
  }, [path]);

  useEffect(() => {
    if (key === "match") {
      handleGitchGenieFilter(true);
    } else {
      handleGitchGenieFilter(false);
    }
  }, [key]);

  return (
    <>
      <Tabs
        className="mb-3"
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => {
          if (path === "/match" && k === "General") {
            navigate(pageURLs?.home);
          }
          setKey(k);
          setLocalStorage("FilterTabKey", k);
        }}
      >
        <Tab eventKey="General" title="Buyers">
          <LeftpanelTabContent
            updateFilter={updateFilter}
            filterQuery={filterQuery}
            setUserLocation={setUserLocation}
            userLocation={userLocation}
            gitchaNotAvailble={gitchaNotAvailble}
            checkGitchaAvailableInLoc={checkGitchaAvailableInLoc}
          />
        </Tab>
        <Tab eventKey="match" title="Match">
          <LeftpanelTabContentRight
            clearFilterGitchaGenie={clearFilterGitchaGenie}
            updateFilterGitchaGenie={updateFilterGitchaGenie}
            selectedProperty={selectedProperty}
            setSelectedProperty={setSelectedProperty}
          />
        </Tab>
      </Tabs>
    </>
  );
};
export default LeftpanelTab;
